import { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { CaretDown, CaretUp } from 'phosphor-react';

// style imports
import '../Input/Input.css';
import './Select.css';

// main component imports
import { LoadingAnimation } from 'Component';
import NameWrapper from 'Hoc/NameWrapper';

const Select = ({ label, isLoading, isError, list, keyName, onChange, value, id, isStudent }) => {
    // Set state to show/hide the list of options
    const [show, setShow] = useState(false);
    const focus = Boolean(value);
    const object = list?.find(item=>item?.id===value)

    // Ref to track the select container element
    const selectRef = useRef(null);

    // Handle option selection
    const handleOnchange = useCallback((e) => {
        if (onChange) {
            onChange(e?.id);
        }
    }, [onChange]);

    // Close dropdown when clicking outside of the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setShow(false); // Close dropdown when clicking outside
            }
        };

        // Add event listener to detect clicks outside
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Toggle dropdown visibility
    const toggleShow = useCallback(() => {
        setShow(prev => !prev);
    }, []);

    // Memoized list of options to avoid re-rendering when not necessary
    const ListOfOption = useMemo(() => {
        if (isLoading) {
            return (
                <div className='select_option_container mues_row_center'>
                    <LoadingAnimation />
                </div>
            );
        }

        if (isError) {
            return (
                <div className='select_option_container mues_row_center'>
                    <h6 className='mues_red mues_font_weight_500'>
                        Something went wrong! Please try refreshing the page.
                    </h6>
                </div>
            );
        }

        if (!list?.length) {
            return (
                <div className='select_option_container mues_row_center'>
                    <h6 className='mues_grey_II mues_font_weight_500'>
                        No Data Found
                    </h6>
                </div>
            );
        }

        return (
            <div className='select_option_container'>
                {list.map(item => (
                    <p key={item.id} className='select_option_card mues_grey_I mues_font_weight_600'
                    onClick={() => handleOnchange(item)}>
                        <NameWrapper>{!isStudent ? keyName ? item[keyName] : `${item.user?.first_name} ${item.user?.last_name}`:
                        `${item.kid?.first_name} ${item.kid?.last_name}`}</NameWrapper>
                    </p>
                ))}
            </div>
        );
    }, [isLoading, isError, list, keyName, handleOnchange, isStudent]);

    return (
        <div className={`form-input select_field_container mues_pointer ${show ? 'active_selected_field' : ''}`}
        onClick={toggleShow} id={id} ref={selectRef}>
            <div className='mues_row_space_between'>
                {object && <p className='mues_grey_I 
                mues_font_weight_600 select_field_text_field'>
                <NameWrapper className={'large_name_wrapper'}>{!isStudent ? keyName ? object[keyName]:`${object?.user?.first_name} 
                ${object?.user?.last_name}`:`${object?.kid?.first_name} ${object?.kid?.last_name}`}</NameWrapper>
                </p>}
                <label className={focus ? 'form_focus' : ''}>{label}</label>
                {show ? <CaretUp className='edit_label mues_pointer' weight='fill' /> : <CaretDown 
                className='edit_label mues_pointer' weight='fill' />}
            </div>
            {show && ListOfOption}
        </div>
    );
};

export default Select;
